// extracted by mini-css-extract-plugin
module.exports =  {"pageBanners":"style-module_pageBanners__jILa3XaFr1v7lvIamXwF","warning":"style-module_warning__BO3WIbC8KZKnEJ4I9Q9V"};